<style scoped lang="css"></style>

<template>
  <div class="main-wrapper">
    <section class="section main-section bg-gradient-default min-vh-100 pt-3">
      <main class="container card shadow shadow-lg--hover mb-3" id="main">
        <Header title="Usuarios" />
        <div class="text-center" :class="loading ? 'mb-3' : ''">
          <b-spinner variant="light" type="grow" v-show="loading"></b-spinner>
        </div>
        <div v-show="!loading">
          <b-row class="mb-3">
            <b-col cols="6">
              <b-button-toolbar>
                <b-button variant="default" size="sm" @click="goBack">
                  <b-icon-chevron-left scale="1.3" />
                </b-button>
                <b-button variant="success" size="sm" v-b-modal.user-form>
                  <b-icon-plus scale="1.7" />
                </b-button>
              </b-button-toolbar>
            </b-col>
            <b-col cols="6">
              <b-button-toolbar class="float-right">
                <b-button-group>
                  <b-button variant="primary" size="sm" @click="refresh">
                    <b-icon-arrow-clockwise scale="1.3" />
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <b-list-group class="mb-3" v-show="!loading">
            <b-list-group-item
              v-for="user in users"
              :key="user.email"
              class="flex-column align-items-start"
            >
              <div class="d-flex justify-content-between">
                <h5 class="mb-1">
                  <a :href="`mailto:${user.email}`">
                    {{ user.email }}
                  </a>
                </h5>

                <b-button
                  variant="danger"
                  size="sm"
                  @click="handleDelete(user.email)"
                >
                  <b-icon-trash size="1.2" />
                </b-button>
              </div>
              <div>
                <p>
                  Tel:
                  <a :href="`tel:${user.phoneNumber}`">{{
                    user.phoneNumber
                  }}</a>
                </p>
                <div>
                  <b-checkbox
                    v-model="user.isAdmin"
                    @change="toggleUserAdmin(user)"
                  >
                    Admin
                  </b-checkbox>
                </div>
                <small class="text-muted">
                  Creado hace {{ user.registeredAt | timestamp }}
                </small>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </main>
    </section>
    <b-modal
      id="user-form"
      centered
      title="Nuevo usuario"
      button-size="sm"
      @ok="handleCreate"
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form-group>
              <b-form-input
                v-model="user.email"
                type="email"
                :state="isFormCompleteAndValid"
                placeholder="Córreo electrónico"
                debounce="200"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <vue-phone-number-input
                show-code-on-list
                v-model="phoneNumber"
                required
                default-country-code="MX"
                @update="handlePhoneInput"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-checkbox v-model="user.isAdmin" switch size="lg">
              Administrativo
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import Header from "./Header";

moment.locale("es");

export default {
  name: "Users",
  components: {
    Header,
  },
  data() {
    return {
      loading: true,
      users: [],
      phoneNumber: "",
      user: {
        email: "",
        phoneNumber: "",
        isAdmin: false,
      },
    };
  },
  created() {
    this.refresh();
  },
  computed: {
    isFormCompleteAndValid() {
      return !!(
        this.user &&
        this.user.email &&
        this.user.email !== "" &&
        this.user.phoneNumber &&
        this.user.phoneNumber !== ""
      );
    },
  },
  methods: {
    ...mapActions("users", [
      "listUsers",
      "createUser",
      "deleteUser",
      "promoteUser",
      "demoteUser",
    ]),
    async refresh() {
      this.loading = true;
      try {
        this.users = await this.listUsers();
      } finally {
        this.loading = false;
      }
    },
    async handleCreate() {
      if (!this.isFormCompleteAndValid) {
        return;
      }

      this.loading = true;
      try {
        await this.createUser({
          email: this.user.email,
          phoneNumber: this.user.phoneNumber,
          isAdmin: this.user.isAdmin === true,
        });

        this.user = { email: "", phoneNumber: "", isAdmin: false };
        this.phoneNumber = "";
      } catch (err) {
        await this.$bvModal.msgOk(`Error al crear usuario, ${err}`, {
          size: "sm",
          title: "Error",
          centered: true,
          footerClass: "p-2 borter-top-0",
        });
      } finally {
        this.refresh();
      }
    },
    handlePhoneInput(event) {
      this.user.phoneNumber = event.e164;
    },
    async toggleUserAdmin(user) {
      await (user.isAdmin ? this.promoteUser(user) : this.demoteUser(user));
      await this.refresh();
    },
    async handleDelete(email) {
      const confirmation = await this.$bvModal.msgBoxConfirm(
        `¿Desea eliminar el usuario "${email}"?`,
        {
          size: "sm",
          centered: true,
          footerClass: "p-2 borter-top-0",
        }
      );

      if (!confirmation) {
        return;
      }

      this.loading = true;
      try {
        await this.deleteUser({ email });
      } catch (err) {
        await this.$bvModal.msgOk(`Error al eliminar usuario, ${err}`, {
          size: "sm",
          title: "Error",
          centered: true,
          footerClass: "p-2 borter-top-0",
        });
      } finally {
        this.loading = false;
        this.refresh();
      }
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
  },
  filters: {
    timestamp(value) {
      return moment(value).fromNow();
    },
  },
};
</script>
